module.exports = __webpack_public_path__ + "static/media/Portrait-10079.ee527dad.jpg";